import React, { useCallback } from 'react'
import { BooleanInput } from 'react-admin'
import { useFormContext } from 'react-hook-form'
import { Organization } from 'services/api/entities/crm/organizations/types/internal/organization-model'
/**
 *
 * @returns a controlled component that allow us set with
 * the same value the value of hasFullAddressCoverage in
 * alls members in arrayInput
 */
const SetAllAddressCoverage = () => {
  const { watch, setValue } = useFormContext<Organization>()
  const members = watch('members')
  const toggleAllMembersCoverage = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      members.forEach((_member, i) => {
        setValue(`members.${i}.hasFullAddressCoverage`, event.target.checked)
      })
    },
    [members, setValue]
  )

  return (
    <BooleanInput
      source="allowFullAddressCoverage"
      onChange={toggleAllMembersCoverage}
      label="form.fields.hasFullAddressCoverage"
    />
  )
}

export default SetAllAddressCoverage
